// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { PolicyEffectType, PolicyFormDetails, StatementService, StatementResource, StatementAction } from '@app/core';

export enum PolicyFormActionTypes {
  SET_POLICY_DETAILS = '[Policy Form] SET_POLICY_DETAILS',
  ADD_STATEMENT = '[Policy Form] ADD_STATEMENT',
  REMOVE_STATEMENT = '[Policy Form] REMOVE_STATEMENT',
  SELECT_EFFECT = '[Policy Form] SELECT_EFFECT',
  SELECT_SERVICE = '[Policy Form] SELECT_SERVICE',
  SELECT_RESOURCE = '[Policy Form] SELECT_RESOURCE',
  SELECT_ACTION = '[Policy Form] SELECT_ACTION',
  CLEAR = '[Policy Form] CLEAR',
  ADD_STATEMENT_WITH_EFFECT = '[Policy Form] ADD_STATEMENT_WITH_EFFECT'
}

export class SetPolicyDetailsAction implements Action {
  readonly type = PolicyFormActionTypes.SET_POLICY_DETAILS;
  constructor(public payload: PolicyFormDetails) {}
}
export class AddStatementAction implements Action {
  readonly type = PolicyFormActionTypes.ADD_STATEMENT;
  // tslint:disable-next-line:no-unnecessary-initializer
  constructor(public payload = undefined) {}
}

export class AddStatementWithEffectAction implements Action {
  readonly type = PolicyFormActionTypes.ADD_STATEMENT_WITH_EFFECT;
  // tslint:disable-next-line:no-unnecessary-initializer
  constructor(public payload = undefined) {}
}

export class RemoveStatementAction implements Action {
  readonly type = PolicyFormActionTypes.REMOVE_STATEMENT;
  constructor(public payload: { statementIdx: number }) {}
}
export class SelectEffectAction implements Action {
  readonly type = PolicyFormActionTypes.SELECT_EFFECT;
  constructor(
    public payload: {
      statementIdx: number;
      effect: PolicyEffectType;
    }
  ) {}
}
export class SelectServiceAction implements Action {
  readonly type = PolicyFormActionTypes.SELECT_SERVICE;
  constructor(
    public payload: {
      statementIdx: number;
      service: StatementService;
    }
  ) {}
}
export class SelectResourceAction implements Action {
  readonly type = PolicyFormActionTypes.SELECT_RESOURCE;
  constructor(
    public payload: {
      statementIdx: number;
      resource: StatementResource;
    }
  ) {}
}

// export class SelectActionAction implements Action {
//   readonly type = PolicyFormActionTypes.SELECT_ACTION;
//   constructor(
//     public payload: {
//       statementIdx: number;
//       action: StatementAction;
//     }
//   ) {}
// }

export class SelectActionActions implements Action {
  readonly type = PolicyFormActionTypes.SELECT_ACTION;
  constructor(
    public payload: {
      statementIdx: number;
      actions: StatementAction[];
    }
  ) {}
}

export class ClearPolicyFormAction implements Action {
  readonly type = PolicyFormActionTypes.CLEAR;
  constructor() {}
}

export type PolicyFormActionsUnion =
  | SetPolicyDetailsAction
  | AddStatementAction
  | RemoveStatementAction
  | SelectEffectAction
  | SelectServiceAction
  | SelectResourceAction
  | SelectActionActions
  | AddStatementWithEffectAction
  | ClearPolicyFormAction;



// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-form.actions.ts